<template>
  <div class="container">
    <div v-if="loading" class="d-flex flex-row" style="align-items: center;justify-content: center;text-align: center;">
      <div class="spinner-border mt-4" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div class="mx-4 col-12" v-else>
      <div class="main">
        <div class="col-12 text-left">
          <h6 style="font-family: 'Arial Black',cursive;
          color: #ff0000;
          ">
            Please don't upload data with size more than 100MB</h6>
        </div>
        <div class="dropzone-container" style="width: 100%;" @dragover="dragover" @dragleave="dragleave" @drop="drop"
          :style="isDragging && 'border-color: green;'">
          <input type="file" multiple name="file" id="fileInput" class="hidden-input" @change="onChange" ref="file" />
          <label for="fileInput" class="file-label">
            <div v-if="isDragging">Release to drop files here.</div>
            <div v-else>Drop files here or <u>click here</u> to upload.</div>
          </label>
          <div class="row">
            <div class="row mt-4" v-if="files.length">
              <template v-for="(file, index) in files" :key="index">
                <div class="col-1">
                  <div>
                    <button class="float-left mb-1 mx-2" type="button" @click="remove(files.indexOf(file))"
                      title="Remove file">
                      <b>×</b>
                    </button>
                  </div>
                  <div>
                    <img class="preview-img" :src=generateURL(file) />
                    <p style="max-width: 50px; max-height: 50px; overflow: hidden;">
                      {{ file.name }}
                    </p>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      <div v-if="isShowCropperModal">
        <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel" aria-modal="true"
          class="modal fade show" role="dialog" style="display: block;" tabindex="-1">
          <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 id="exampleModalFullscreenLabel" class="modal-title h4">Picture Cropper</h5>
                <button aria-label="Close" class="btn-close" data-bs-dismiss="modal" type="button"
                  @click="skip"></button>
              </div>
              <div class="modal-body" style="height: 70vh; overflow-y: auto;">
                <div class="d-flex justify-content-center align-items-center mb-3">
                  <label class="me-2">Width:</label>
                  <input type="number" v-bind:value="tempWidth" @input="updateTempWidth($event)" min="50"
                    class="form-control me-3" style="width: 100px;" />

                  <label class="me-2">Height:</label>
                  <input type="number" v-bind:value="tempHeight" @input="updateTempHeight($event)" min="50"
                    class="form-control" style="width: 100px;" />

                  <button class="btn btn-primary ms-3" @click="setPreset">Resize</button>
                </div>
                <VuePictureCropper :key="presetMode" :boxStyle="{
                  width: '100%',
                  height: '300px',
                  backgroundColor: '#f8f8f8',
                }" :img="pic" :options="{
                  viewMode: 1,
                  dragMode: 'crop',
                  aspectRatio: NaN,
                  cropBoxResizable: true,
                }" :presetMode="presetMode" @ready="ready" />

                <div style="display: flex; justify-content: center; align-items: center;">
                  <h5>{{ this.currentFile ? this.currentFile.name : '' }}</h5>
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-info" type="button" @click="reset">Reset</button>
                <button class="btn btn-danger" data-bs-dismiss="modal" type="button" @click="skip">Skip</button>
                <button class="btn btn-success" data-bs-dismiss="modal" type="button"
                  @click="getCroppedImg">Crop</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class=" d-flex flex-row-reverse">
        <button class="btn btn-primary mt-3" @click="uploadFile">
          <i class="fas fa-cloud-upload-alt"></i> Upload
        </button>
      </div>
    </div>
  </div> 
</div> 
</template>

<script>
import MediaService from "@/services/media.service";
import { notify } from "@kyvg/vue3-notification";
import VuePictureCropper, { cropper } from 'vue-picture-cropper';

export default {
  name: 'uploadMedia',
  data() {
    return {
      imageUrl: null,
      selectedFile: null, // New selected file state
      loading: false, // New loading state
      isDragging: false,
      files: [],
      error: false,
      errorMessage: null,
      uploadSuccessful: false,
      filesToCrop: [],
      currentFile: null,
      isShowCropperModal: false,
      pic: '',
      presetMode: {
        mode: 'fixedSize',
        width: 200,
        height: 200,
      },
      tempWidth: 200,
      tempHeight: 200,
      presetWidth: 200,
      presetHeight: 200,
    };
  },
  components: {
    // DropFile,
    VuePictureCropper,
  },
  methods: {
    handleFileChange(event) {
      // Handle file selection
      this.selectedFile = event.target.files[0];
      this.imageUrl = URL.createObjectURL(this.selectedFile);
    },
    cancelSelectedImage() {
      this.selectedFile = null;
      this.imageUrl = null;
    },

    async uploadFile() {
      this.uploadSuccessful = false;
      if (this.files.length == 0) {
        this.showNotification('error', 'Please select a file');
        return;
      }
      this.loading = true;
      var response;
      for (let index = 0; index < this.files.length; index++) {
        var formData = new FormData();
        this.loading = true;
        formData.append('image', this.files[index]);
        try {
          response = await MediaService.uploadFile(formData);
          if (response.data) {
            if (response.data.messageCode != 1) {
              this.error = true;
              this.errorMessage = response.data.message;
            }
          }
        } catch (error) {
          this.loading = false;
          this.showNotification('error', error);
          this.clearSubmit();
        }
        this.loading = false;
      }
      if (this.error) {
        this.showNotification('error', this.errorMessage);
        this.clearSubmit();
      } else {
        this.uploadSuccessful = true;
        this.$emit('isUploadSuccessful', this.uploadSuccessful);
        this.showNotification('success', response.data.message);
        this.clearSubmit();
      }
    },
    clearSubmit() {
      this.files = [];
      this.error = false;
      this.errorMessage = null;
    },
    showNotification(type, message) {
      notify({
        type: type,
        title: 'Upload Media',
        text: message
      });
    },
    onChange() {
      const fileInput = this.$refs.file;
      if (!fileInput || !fileInput.files.length) return;

      const selectedFiles = Array.from(fileInput.files);

      selectedFiles.forEach(file => {
        if (file.type.startsWith("image/")) {
          this.filesToCrop.push(file);
        } else {
          this.files.push(file);
        }
      });
      if (!this.isShowCropperModal && this.filesToCrop.length > 0) {
        this.processNextFile();
      }
    },
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.onChange();
      this.isDragging = false;
    },
    remove(i) {
      this.files.splice(i, 1);
    },
    generateURL(file) {
      let fileSrc = URL.createObjectURL(file);
      setTimeout(() => {
        URL.revokeObjectURL(fileSrc);
      }, 1000);
      return fileSrc;
    },
      ready() { 
      console.log('ready cropper');
    },
    async getCroppedImg() {
      if (!cropper) return;

      const blob = await cropper.getBlob();
      if (!blob) return;

      const fileType = this.currentFile.type;
      const croppedFile = new File([blob], this.currentFile.name, { type: fileType });

      this.files.push(croppedFile);

      if (this.filesToCrop.length > 0) {
        this.processNextFile();
      } else {
        this.pic = '';
        this.isShowCropperModal = false;
        this.$refs.file.value = '';
      }
    },
    reset() {
      if (cropper) cropper.reset();
      this.resetPreset();
    },
    skip() {
      if (cropper) cropper.clear();
      if (!this.files.includes(this.currentFile)) {
        this.files.push(this.currentFile);
      }
      if (this.filesToCrop.length > 0) {
        this.processNextFile();
      } else {
        this.pic = '';
        this.isShowCropperModal = false;
        this.$refs.file.value = '';
      }
    },
    processNextFile() {
      this.resetPreset();
      this.currentFile = this.filesToCrop.shift();
      this.pic = URL.createObjectURL(this.currentFile);
      this.isShowCropperModal = true;
    },
    updateTempWidth(event) {
      this.tempWidth = event.target.value;
    },
    updateTempHeight(event) {
      this.tempHeight = event.target.value;
    },
    setPreset() {
      this.presetWidth = this.tempWidth;
      this.presetHeight = this.tempHeight;

      this.presetMode = {
        mode: 'fixedSize',
        width: parseInt(this.presetWidth),
        height: parseInt(this.presetHeight),
      };
    },
    resetPreset() {
      this.presetWidth = this.tempWidth = 200;
      this.presetHeight = this.tempHeight = 200;
      this.presetMode = {
        mode: 'fixedSize',
        width: parseInt(this.presetWidth),
        height: parseInt(this.presetHeight),
      };
    }
  }
};
</script>

<style scoped>
.main {
  /* display: flex;
  flex-grow: 1; */
  align-items: center;
  justify-content: center;
  text-align: center;
}

.dropzone-container {
  padding: 4rem;
  background: #f7fafc;
  border: 1px solid #e2e8f0;
  background-color: white;
}

.hidden-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}

.file-label {
  font-size: 20px;
  display: block;
  cursor: pointer;
}

.preview-container {
  display: flex;
  margin-top: 2rem;
}

.preview-card {
  display: flex;
  border: 1px solid #a2a2a2;
  padding: 5px;
  margin-left: 5px;
}

.preview-img {
  width: 70px;
  height: 70px;
  border-radius: 5px;
  border: 1px solid #a2a2a2;
  background-color: #a2a2a2;
}

.dropzone-container {
  border: 2px dashed;
  border-color: #9e9e9e;
}
</style>